export default {
  catalog: {
    pageTitle: "Catálogo",
    subtitle: "Busca en todo el catálogo CIMA y añade productos a tu portfolio o a tus competidores",
    searchPlaceholder: "Buscar por nombre, CN, principio activo o laboratorio…",
    prompt: "Escribe al menos 2 caracteres para buscar en el catálogo CIMA.",
    loading: "Buscando…",
    noResults: "Sin resultados en el catálogo.",
    colProduct: "Producto",
    colActiveIngredient: "P. Activo",
    colLaboratory: "Laboratorio",
    colStatus: "Estado",
    marketed: "Comercializado",
    notMarketed: "No comercializado",
    inPortfolio: "En Mis Productos",
    inCompetitors: "En Competidores",
    viewSheet: "Ver ficha",
    addToPortfolio: "Añadir a Mis Productos",
    addToCompetitors: "Añadir a Competidores",
    addedPortfolio: "Añadido a Mis Productos",
    addedCompetitor: "Añadido a Competidores",
    btnPortfolio: "+ Mis productos",
    btnCompetitors: "+ Competidores",
    short_portfolio: "Míos",
    short_competitor: "Comp.",
    bulkIntro: "{n} productos con este filtro.",
    bulkToPortfolio: "Añadir todos a Mis productos",
    bulkToCompetitors: "Añadir todos a Competidores",
    bulkNote: "Solo los comercializados; los que ya estén se saltan.",
    bulkAddedPortfolio: "{n} añadidos a Mis productos ({skipped} ya estaban).",
    bulkAddedCompetitors: "{n} añadidos a Competidores ({skipped} ya estaban).",
    bulkParallel: "{n} son importaciones paralelas y quedan en Competidores hasta que decidas.",
    addError: "No se pudo añadir",
    parallelImport: "Importación paralela",
    parallelImportIp: "Importación paralela: el nº de registro {nreg} lleva el sufijo IP. La comercializa un tercero; cuenta como competencia salvo que la declares propia.",
    parallelImportForeign: "Autorizada en otro país de la UE (nº de registro {nreg}). La comercializa un tercero; cuenta como competencia salvo que la declares propia.",
    addedAsParallelImport: "Es una importación paralela: está en Competidores hasta que decidas en Mis productos",
  },
};
